import { Popover, Box } from "@mui/material";
import { Picker } from "emoji-mart";
import React from "react";
import { useSelector } from "react-redux";

const EmojiPicker = ({ onSelectEmoji, reaction, disabled }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const { userData } = useSelector((state) => state.user);
  const openEmoji = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const closeEmoji = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const handleSelect = (e) => {
    onSelectEmoji(e);
    if (reaction) {
      closeEmoji();
    }
  };
  return (
    <>
      <button
        type="button"
        className={`emoji_picker btn-default hint ${
          reaction ? "hint-bottom" : "hint-top"
        }`}
        disabled={disabled || userData?.community_status?.banned == true}
        onClick={openEmoji}
        aria-label={reaction ? "Reaction" : "Emoji"}
      >
        {!reaction && (
          <Box
            component="img"
            src="/images/Smiley.svg"
            width="20"
            height="20"
            alt="smiley icon"
          />
        )}
        {reaction && <img src="/images/community/reaction-icon.svg" alt="" />}
      </button>

      <Popover
        id={"emoji-popover"}
        open={open}
        anchorEl={anchorEl}
        onClose={closeEmoji}
        className={reaction ? "emoji_picker_remove_width" : ""}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "origin",
        }}
      >
        <Picker onSelect={handleSelect} />
      </Popover>
    </>
  );
};

export default EmojiPicker;
